/**
 * The Upcoming Payments table's cancel-eligibility rule — the one piece of formatting logic
 * specific to this table. Locale-aware date display formatting lives in the shared
 * `useFormatDate` hook's `formatDateOnly` (`@mdvip/shared/hooks/useFormatDate`); account-cell
 * derivation lives in `accountDisplay.format.ts` — both shared with other payment tables.
 */

import { isSameDay, parseISO } from 'date-fns';

/**
 * True when `scheduledDate` is today in the member's local timezone — matches legacy's
 * eligibility check (browser-local `toDateString()` comparison), without legacy's UTC-midnight
 * parsing bug: `parseISO` treats a bare date-only string as local midnight, not UTC midnight.
 */
export function isScheduledToday(scheduledDate: string, now: Date = new Date()): boolean {
  return isSameDay(parseISO(scheduledDate), now);
}
